var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntranceSelectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60156 25.2001V22.8001H6.00156V6.0001C6.00156 5.3401 6.23656 4.7751 6.70656 4.3051C7.17656 3.8351 7.74156 3.6001 8.40156 3.6001H20.4016C21.0616 3.6001 21.6266 3.8351 22.0966 4.3051C22.5666 4.7751 22.8016 5.3401 22.8016 6.0001V22.8001H25.2016V25.2001H3.60156ZM18.0016 22.8001H20.4016V6.0001H15.0016V4.6801C15.8816 4.8401 16.6016 5.2501 17.1616 5.9101C17.7216 6.5701 18.0016 7.3401 18.0016 8.2201V22.8001ZM13.2016 15.6001C13.5416 15.6001 13.8266 15.4851 14.0566 15.2551C14.2866 15.0251 14.4016 14.7401 14.4016 14.4001C14.4016 14.0601 14.2866 13.7751 14.0566 13.5451C13.8266 13.3151 13.5416 13.2001 13.2016 13.2001C12.8616 13.2001 12.5766 13.3151 12.3466 13.5451C12.1166 13.7751 12.0016 14.0601 12.0016 14.4001C12.0016 14.7401 12.1166 15.0251 12.3466 15.2551C12.5766 15.4851 12.8616 15.6001 13.2016 15.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntranceSelectorIcon);
export default __webpack_public_path__ + "static/media/EntranceSelectorIcon.f2515400c82a8fe6d42eb33e802cf23d.svg";
export { ForwardRef as ReactComponent };